import React from 'react'

import { Game } from '../../../Game'
import { Props } from '../GamesGrid'
import { useGamesFromSlugs } from '../hooks'
import { useDesktopGamesGridWidth } from './hooks'
import { DesktopGamesGridBox } from './styles'
import { minDesktopGameWidthInPx } from './utils'

export function DesktopGamesGrid({ rows, gameSlugs }: Props) {
  const width = useDesktopGamesGridWidth()
  const maxGames = rows * Math.floor(width / minDesktopGameWidthInPx)
  const gamesFromSlugs = useGamesFromSlugs(gameSlugs.slice(0, maxGames))

  return (
    <DesktopGamesGridBox rows={rows}>
      {gamesFromSlugs.map((game) => (
        <Game
          key={game.slug}
          game={game}
        />
      ))}
    </DesktopGamesGridBox>
  )
}
